import styled, { keyframes } from "styled-components";
import { Autorenew } from "@mui/icons-material";

export const SpinnerWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.8);
  position: absolute;
  z-index: 1000000;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Turner = styled(Autorenew)`
  animation: ${spin} 2s linear infinite;
  color: #FFFFFF;
`;
